module.exports = __webpack_public_path__ + "static/media/Lido-Citta-Logo.a3a3365c.png";